import { ThisNumberExplainedRow } from '@futrli-sdk/predict';

import { ConsolidatedForecastReportStructure, NodeInfoWithRef } from '../../../core/types';
import { CATEGORY_NAME_INDEXES } from '../../../core/constants';
import { RowStyleOptions } from '../reports/data-grid/types';

export interface ForecastLayoutItem<T> {
  adjustTreeBeforeRender?: (nodes: ForecastTreeNode[]) => ForecastTreeNode[];
  category: CATEGORY_NAME_INDEXES;
  datasource: keyof ConsolidatedForecastReportStructure;
  displayType: T;
  nodes?: ForecastTreeNode[];
  options?: Partial<RowStyleOptions>;
  totalNode?: ForecastTreeNode;
  totalOptions?: Partial<RowStyleOptions>;
}

export type UKForecastLayoutItem = ForecastLayoutItem<UKForecastLayoutItemDisplayType>;
export enum UKForecastLayoutItemDisplayType {
  totalWithAccounts = 'totalWithAccounts',
  calculation = 'calculation',
  accounts = 'accounts'
}

export type FRForecastLayoutItem = ForecastLayoutItem<FRForecastLayoutItemDisplayType>;
export enum FRForecastLayoutItemDisplayType {
  headingWithTopLevelAccounts = 'headingWithTopLevelAccounts',
  topLevelAccounts = 'topLevelAccounts'
}

export interface ForecastTree {
  tree: ForecastTreeNode[];
  index: Record<string, ForecastTreeNode>;
}

export interface ForecastTreeNode extends NodeInfoWithRef {
  average_days_to_pay?: number;
  childCount: number;
  children: ForecastTreeNode[];
  row?: string[];
  isFirst: boolean;
  isLast: boolean;
  is_unused: boolean;
  level: number;
  parentRef?: string;
  siblingCount: number;
  siblingIndex: number;
  system_account_role?: string | null;
  thisNumberExplained?: ThisNumberExplainedRow;
  is_excel_assumption?: boolean | null;
}
